/* Settle redesign: tiny progressive enhancements. Everything works without this file. */
(function () {
  // Bundle feature: keep the comparison and button price in step with the chosen size.
  document.querySelectorAll('[data-st-bundle]').forEach(function (form) {
    function sync() {
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      form.querySelectorAll('[data-st-price]').forEach(function (el) { el.textContent = r.dataset.price; });
      form.querySelectorAll('[data-st-separate]').forEach(function (el) { el.textContent = r.dataset.separate; });
      form.querySelectorAll('[data-st-saving]').forEach(function (el) { el.textContent = r.dataset.saving; });
      form.querySelectorAll('[data-st-size]').forEach(function (el) { el.textContent = r.dataset.size; });
    }
    form.addEventListener('change', sync);
    sync();
  });
})();

/* Variant-aware Settle blocks: Horizon doesn't re-render custom blocks on size change, so
   blocks render one line per variant (data-st-variant) and we show the selected one. */
(function () {
  function show(id) {
    if (!id) return;
    document.querySelectorAll('[data-st-variant]').forEach(function (el) {
      el.hidden = String(el.dataset.stVariant) !== String(id);
    });
  }
  document.addEventListener('variant:update', function (e) {
    var v = e.detail && e.detail.resource; if (v && v.id) show(v.id);
  });
  function current() {
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('.product-information form input[name="id"], product-form-component input[name="id"]');
    return input && input.value;
  }
  var timer;
  function follow() {
    // Horizon updates the URL and form after it fetches the new variant; keep checking briefly.
    var ticks = 0;
    clearInterval(timer);
    timer = setInterval(function () {
      show(current());
      if (++ticks > 30) clearInterval(timer);
    }, 100);
  }
  ['change', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('variant-picker')) follow();
    });
  });
  window.addEventListener('popstate', follow);
  show(current());
})();

/* Sticky Add to cart bar (phones): shows once the main button is scrolled past. */
(function () {
  var bar = document.querySelector('[data-st-sticky]');
  if (!bar) return;
  function mainBtn() {
    return document.querySelector('.product-information add-to-cart-component button, .product-information button[name="add"], product-form-component button[type="submit"]');
  }
  var btn = mainBtn();
  if (!btn || !('IntersectionObserver' in window)) return;
  document.body.appendChild(bar);
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.hidden = !past;
      document.documentElement.classList.toggle('st-has-sticky', past);
    });
  });
  io.observe(btn);
  bar.querySelector('[data-st-sticky-btn]').addEventListener('click', function () {
    var b = mainBtn();
    if (!b) return;
    if (b.disabled) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    b.click();
  });
})();
